// ─── The toast layer ─────────────────────────────────────────────
//
// The app's toasts (`ToastContainer`, and `ReloadPrompt`, which renders as one)
// portal to <body> on a band of their own, `--z-toast`: above every sheet, wizard,
// popover and menu, and below only the auth gate (`--z-lock`). They used to render
// inside #root, and #root is a stacking context of its own (`z-index: 1` in
// index.css), so a toast's z-index only ever ranked it among #root's children —
// every BottomSheet, the feedback thread popover and every menu portal to <body>
// and painted over it. A toast raised while one was open was invisible. (b-02055)
//
// Over everything means a press on a toast is a press on the toast, and a surface
// underneath that closes on an outside press must not read it as one: dismissing
// the toast that says a send failed must not also close the thread the text came
// back to. Such a surface asks `isInToastLayer`.
//
// Pure DOM and importing nothing from components/, like `menuLayer`, so any
// surface can read it without an import cycle.

/** The class on the layer's container — and what `isInToastLayer` looks for. */
export const TOAST_LAYER_CLASS = 'toast-container';

/** Inside the toast layer: a toast, its action or its dismiss button. */
export function isInToastLayer(t: EventTarget | null): boolean {
  return t instanceof Element && !!t.closest(`.${TOAST_LAYER_CLASS}`);
}
